import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { useTranslation } from 'react-i18next';
import { ESettingsWorkspaceTab } from '../ESettingsWorkspaceTab';
import { TabSettingsWorkspaceWrapper } from '../_base/TabSettingsWorkspaceWrapper';
import { USButtonCreditsAdd } from './USButtonCreditsAdd';
import { USViewCreditsBalance } from './USViewCreditsBalance';

import { use_dispatch } from '@/hooks/_base/use_dispatch';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';

export const TabSettingsWorkspaceCreditsTopUp = () => {
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  /*
   * HTML
   */

  return (
    <TabSettingsWorkspaceWrapper type={ESettingsWorkspaceTab.CREDITS_TOP_UP} required_owner_access>
      <div className="flex flex-col justify-start items-start mt-2 gap-3  text-page-foreground">
        <span className="text-xl">{t(i18n_page_settings_workspace.tabs.credits.general_component.title)}</span>

        <div className="w-9" />
        <USViewCreditsBalance />

        <span className="text-xl">{t(i18n_page_settings_workspace.tabs.credits.general_component.top_up_credits_balance)}</span>

        <div className={`flex flex-wrap   items-center  ${md(' justify-between w-full gap-x-4 gap-y-4', ' justify-start w-[60rem] gap-10')}`}>
          <USButtonCreditsAdd amount={500} />
          <USButtonCreditsAdd amount={1000} />
          <USButtonCreditsAdd amount={2000} />
          <USButtonCreditsAdd amount={5000} />
          <USButtonCreditsAdd amount={10000} />
          <USButtonCreditsAdd amount={20000} />
        </div>
      </div>
    </TabSettingsWorkspaceWrapper>
  );
};
